import { gsap } from "gsap";
import i18n from '../i18n'

const lib = {
  req(req, store, router) {
    if (typeof req.data == "undefined") {
      req.data = { data: {} };
    }
    req.data.origin_forwarded = window.location.host;
    if (store.state.pay_pass) {
      req.data.data.cabinet_pay_password = store.state.pay_pass;
      store.commit("PAY_PASS", false);
    }
    req.data.device_fingerprint = store.state.fingerprint;
    req.data.lang = localStorage.getItem("lang");
    if (req.data.no_loader) {
      delete req.data.no_loader;
    } else {
      store.commit("LOADER", true);
      store.commit('SET_ACTIVE_LOADING', req.url);
      console.log('ACTIVE_LOADINGS', Object.keys(store.state.active_loadings).length);
    }
    if (req.data.no_error_msg) {
      req.no_error_msg = true;
      delete req.data.no_error_msg;
    }
    if (store.state.config.CONSOLE_LOGS) {
      console.log(req.url, req);
    }
  },

  res(res, store, router) {
    if (store.state.config.CONSOLE_LOGS) {
      console.log(res.config.url, res);
    }
    store.commit('DEL_ACTIVE_LOADING', res.config.url);
    console.log('ACTIVE_LOADINGS', Object.keys(store.state.active_loadings).length)
    if (Object.keys(store.state.active_loadings).length === 0) {
      store.commit("LOADER", false);
    }
    if (res.data.isLogged === true) {
      store.commit("IS_LOGGED", res.data.isLogged);
      if (!store.state.domains && res.data.body.domains) {
        store.commit("DOMAINS", res.data.body.domains);
      }
    } else if (res.data.isLogged === false) {
      store.commit("IS_LOGGED", res.data.isLogged);
      // store.commit('USER_DATA', {});
      if (!store.state.domains && res.data.body.domains) {
        store.commit("DOMAINS", res.data.body.domains);
      }
      if (store.state.domains) { 
        let host = window.location.protocol + "//" + store.state.domains.AUTH_DOMAIN + (process.env.VUE_APP_TOR === 'true' ? "/auth" : "");
        window.location.href = host;
      }
      store.commit("USER_DATA", {});
      // window.location.href = 'http://auth.dev.pro';
      // if (!res.data.body.alter) {
      //     store.commit('MODAL', {
      //         action: false,
      //         type: false,
      //         content: false,});
      // }
      // store.commit('DARK_WRAPPER', false);
    } else {
      router.push("/unexpected");
    }
    if (res.data.modal) {
      if (res.data.modal == "repeat") {
        res.data.body.repeat_url = res.config.url;
      }
      if (
        this.inArray(res.config.url, ["SearchMember", "GetComiss", "checkUnique"]) &&
        res.data.modal != "questionnaire"
      ) {
        if (res.data.risk_form) {
          store.commit("MODAL_ACTION", true);
          store.commit("MODAL_TYPE", "questionnaire");
          store.commit("MODAL_CONTENT", res.data.risk_form);
        }
        return;
      }
      if (res.data.modal == "answer") { 
        const warningObject = {
          warningType: 'notification',
          warningText: res.data.body.result_text,
        };
        store.commit("WARNING", warningObject); 
      } else {
        store.commit("MODAL_ACTION", true);
        store.commit("MODAL_TYPE", res.data.modal);
        store.commit("MODAL_CONTENT", res.data.body);
      }
    }
    if (res.data.error) {
      if (this.inArray(res.config.url, ["GetComiss", "SearchMember"])) {
        return;
      }
      if (res.config.no_error_msg) {
        return;
      }
      const warningObject = {
        warningType: 'error',
        warningText: res.data.body.result_text,
      };
      if(res.data.body.result == '853') {
        warningObject.warningText = res.data.body.result_text + ' ' + res.data.body.advanced.notify_text;
      }
      store.commit("WARNING", warningObject); 
      // if (
      //   res.data.body.result != "4020" &&
      //   res.data.body.result != "4010"
      // ) {
      //   alert(`ERROR: ${res.data.body.result_text}`);
      // }
    }
    if (res.data.body && res.data.body.updating) {
      if (res.data.body.updating.keyts) {
        store.commit("USER_DATA_KEYTS", res.data.body.updating.keyts);
        store.commit("GLOBAL_KEY_KEYT");
      }
      if (res.data.body.updating.templates) {
        store.commit("USER_DATA_TEMPLATES", res.data.body.updating.templates);
      }
      if (res.data.body.updating.currs) {
        store.commit("CURR_LIST", res.data.body.updating.currs);
      }
      if (res.data.body.updating.user_info) {
        let inf = res.data.body.updating.user_info;
        store.commit("USER_DATA_INFO", inf);
        if (inf.avatar) {
          let av = "";
          if (inf.avatar.value.length > 0) {
            av = inf.avatar.value[0].body;
          }
          store.commit("USER_DATA_AVATAR", av);
        }
      }
    }
    if (res.data.risk_form) {
      store.commit("MODAL_ACTION", true);
      store.commit("MODAL_TYPE", "questionnaire");
      store.commit("MODAL_CONTENT", res.data.risk_form);
    }
  },

  err(err, store, router) {
    store.commit("LOADER", false);
    if (err.response) {
      alert(`CODE: ${err.response.status}\n ${err.response.statusText}`);
    } else {
      alert("Unexpcected Http Error");
    }
  },

  checkRegExp(str, reg) {
    let regexp = new RegExp(reg);
    return regexp.test(str);
  },

  throwWarning(store, str, type = 'error') {
    const warningObject = {
      warningType: type,
      warningText: str,
    };
    store.commit("WARNING", warningObject); 
  },

  alertE(store, body) {
    store.commit("MODAL_ACTION", true);
    store.commit("MODAL_TYPE", "answer");
    store.commit("MODAL_CONTENT", body);
  },

  isInt(x) {
    var y = parseInt(x);
    if (isNaN(y)) return false;
    return x == y && x.toString() == y.toString();
  },

  HardcodeCurrPrecision(curr, amount) {
    return amount.split(".").pop().length || 2;
  },

  inArray(curr, arr) {
    if (arr.indexOf(curr) != -1) {
      return true;
    } else {
      return false;
    }
  },

  RandomDigit(len) {
    var r;
    var digit = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");

    let pasw = "";

    for (var i = 0; i < len; i++) {
      r = Math.floor(Math.random() * 9);
      pasw += digit[r];
    }
    return pasw;
  },

  cRound(num) {
    return Math.floor(num * 100) / 100;
  },
  
  getTokenString(str, lng) {
    let s = str.substring(0, lng);
    s += "...";
    s += str.substring(str.length - lng, str.length);
    return s;
  },

  getFormattedNumber(str) {
    const num = Number(str);
    if(isNaN(num)) return str;
    // formatting number with thousand separator
    return num.toLocaleString('ru-RU');
  },

  formatNumberWithSeparators(num) {
    if (typeof num !== 'number' && typeof num !== 'string') {
      return num;
    }
    
    const str = String(num);
    
    const parts = str.split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1] || '';
    
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    
    if (decimalPart) {
      return `${formattedInteger}.${decimalPart}`;
    } else {
      return formattedInteger;
    }
  },

  sortArr(k, s) {
    let arr = k;
    // console.log(arr)
    if (!Array.isArray(arr)) {
      console.log(new Error("Sorted list is not Array!"));
      return arr;
    }
    if (arr.length <= 1) {
      return arr;
    }
    // console.log(arr)
    if (s.ind && typeof arr[0][s.ind] !== "undefined" || s.type === 'rate' || s.type === 'offer_curr' || s.type === 'history_params') {
      arr.sort((a, b) => {
        let r = 0;
        let x, y;
        if (s.type == "date" && a[s.ind] && b[s.ind]) {
          // Если дата в формате 05.09.2025 12:02:04, то переделываем
          if(a[s.ind].includes('.')) {
            x = new Date(a[s.ind].replaceAll('.', '-').split(' ')[0].split('-').reverse().join('-') + 'T' + a[s.ind].split(' ')[1]);
          } else {
            x = new Date(a[s.ind]);
          }
          if(b[s.ind].includes('.')) {
            y = new Date(b[s.ind].replaceAll('.', '-').split(' ')[0].split('-').reverse().join('-') + 'T' + b[s.ind].split(' ')[1]);
          } else {
            y = new Date(b[s.ind]);
          }
        } else if (s.type == "int") {
          x = Number(a[s.ind]);
          y = Number(b[s.ind]);
        } else if(s.type == 'rate') {
          x = Number(a.amount_to / a.amount_from);
          y = Number(b.amount_to / b.amount_from);
        } else if(s.type == 'history_params') {
          x = a.param_value + ' ' + a.comment;
          y = b.param_value + ' ' + b.comment;
        } else if(s.type == 'offer_curr') {
          if(s.ind == 'pay') {
            if(a.internal_direction == 'Maker2taker' && a.external_curr_text && !a.external_type_text) {
              x = a.external_curr_text
            } else {
              x = a.internal_direction == 'Maker2taker' ? a.external_type_text.toLowerCase() : a.internal_curr_text
            }
            if(b.internal_direction == 'Maker2taker' && b.external_curr_text && !b.external_type_text) {
              y = b.external_curr_text
            } else {
              y = b.internal_direction == 'Maker2taker' ? b.external_type_text.toLowerCase() : b.internal_curr_text
            }
          } else {
            if(a.internal_direction == 'Maker2taker' && a.external_curr_text && !a.external_type_text) {
              x = a.external_curr_text
            } else {
              x = a.internal_direction == 'Maker2taker' ?  a.internal_curr_text : a.external_type_text.toLowerCase()
            }
            if(a.internal_direction == 'Maker2taker' && a.external_curr_text && !a.external_type_text) {
              y = b.external_curr_text
            } else {
              y = b.internal_direction == 'Maker2taker' ?  b.internal_curr_text : b.external_type_text.toLowerCase()
            }
          }
        } else {
          x = a[s.ind];
          y = b[s.ind];
        }
        if(s.ind == 'cover_percent') {
          if(a.category == 'Electronic money token (EMT token)') {
            x = Number(a.cover_percent);
          } else {
            // Давно созданные токены могут иметь категорию ART и обеспеченность в cover_percent, т.к. cover_amount не было
            if(!Number(a.cover_amount)) {
              x = Number(a.cover_percent);
            } else {
              x = Number(a.cover_amount);
            }
          }
          if(b.category == 'Electronic money token (EMT token)') {
            y = Number(b.cover_percent);
          } else {
            if(!Number(b.cover_amount)) {
              y = Number(b.cover_percent);
            } else {
              y = Number(b.cover_amount);
            }
          }
        }
        if (x >= y) {
          s.to ? (r = -1) : (r = 1);
        } else if (x < y) {
          s.to ? (r = 1) : (r = -1);
        }
        // console.log(r)
        return r;
      });
      // console.log(k)
    }
    return arr;
  },
  precRound(context, num, prec) {
    if (prec > 15) {
      try {
        return this.toLongFixed(context, num, prec); 
      } catch (err) {
        console.log(err); 
        return "undefined";
      }
    } else {
      try {
        return context.$math.format(context.$math.round(num, prec), { notation: "fixed" });
      } catch (err) {
        console.log(err);
        return "undefined";
      }
    }
  },
  bignumberToHumanValue(bgn) {
    let l = bgn.length;
    let ind = l % 3 != 0 ? l % 3 : 3;
    let rz = {
        10: 'B',
        11: 'B',
        12: 'B',
        13: 'T',
        14: 'T',
        15: 'T',
        16: 'Q',
        17: 'Q',
        18: 'Q',
        19: 'Q2',
        20: 'Q2',
        21: 'Q2',
        22: 'S',
        23: 'S',
        24: 'S'
    }
    return [bgn.substring(0, ind), l in rz ? rz[l] : `> 100 ${rz[24]}`];
  },
  formatNum(context, num, prec) {
    const parts = num.toString().split('.')
    if (parts[0] >= 1000000000) {
        return (parts[0] / 1000000000).toFixed(1) + 'B';
    } 
    if (parts[0] >= 1000000) {
        return (parts[0] / 1000000).toFixed(1) + 'M';
    }
    if(parts[0] >= 1000) {
      return (parts[0] / 1000).toFixed(2) + 'K';
    }
    if(prec > 4) {
      
        return this.toLongFixed(context, num, 4)
    }    
    return context.$math.format(context.$math.round(num, prec), { notation: "fixed" });
  },
  toLongFixed(context, number, precision) {
    // console.log('toLongFixed');
    number = Number(number);
    if (number === 0) {
        return "0";
    }

    const strNumber = number.toString();
    const decimalIndex = strNumber.indexOf(".");
    // console.log('toLongFixed decimalIndex', decimalIndex);
    if (decimalIndex === -1) {
        return strNumber;
    }

    const lengthEnd = strNumber.length - (decimalIndex + 1);

    // если длина хвоста меньше или равна точности, то округлять не нужно
    if (lengthEnd <= precision) {
        return strNumber;
    }

    // если длина хвоста больше точности, то надо обрезать строку по точности
    const nextCharIndex = decimalIndex + precision + 1;

    if (strNumber[nextCharIndex] !== "0") {
        const roundedNumber = Number(strNumber.slice(0, nextCharIndex)) + 1e-15; // Adding a small epsilon to ensure correct rounding
        return context.$math.format(Number(roundedNumber.toFixed(precision)), { notation: "fixed" });
    } else {
        return context.$math.format(Number(strNumber.slice(0, nextCharIndex)).toFixed(precision), { notation: "fixed" });
    }
  },
  ev(context, exp) {
    try {
      return context.$math.format(context.$math.evaluate(exp), { notation: "fixed" });
    } catch (err) {
      console.log(err);
      return "undefined";
    }
  },
  getRate(context, prec_rate, rate, from_text, to_text, revers = false) {
    let rate_from, rate_to;
    if (Number(rate) >= 1) {
      rate_from = revers ? "1" : String(rate);
      rate_to = revers ? String(rate) : "1";
    } else {
      rate_from = revers ? this.ev(context, `1 / ${rate}`) : "1";
      rate_to = revers ? "1" : this.ev(context, `1 / ${rate}`);
    }

    return `<span>${this.precRound(
      context,
      rate_from,
      prec_rate
    )} <span class='grey fs_08'>${from_text}</span> = ${this.precRound(
      context,
      rate_to,
      prec_rate
    )} <span class='grey fs_08'>${to_text}</span></span>`;
  },
  getCorrespondentName(deal, userId) {
    if (deal.internal_sender_uid == userId) {
      return deal.internal_recipient_name ? deal.internal_recipient_name : deal.internal_recipient_uid;
    }

    return deal.internal_sender_name ? deal.internal_sender_name : deal.internal_sender_uid;
  },
  cutDescription(str, length) {
    if (str.length > length) {
      return str.substring(0, length) + "…";
    }
    return str;
  },
  getClassDeal(status) {
    // статусы 10, 20 - серый цвет
    if (status == "10" || status == "20") {
      return "status-grey";
    }

    // статусы 30, 40 - цвет уведомлений
    if (status == "30" || status == "40") {
      return "status-notification";
    }

    // статусы 50, 60 - оранжевый цвет (арбитраж)
    if (status == "50" || status == "60") {
      return "status-orange";
    }

    // статус 100 - зеленый цвет (завершена)
    if (status == "100") {
      return "status-ended";
    }

    // статус 130 - красный цвет (отменена)
    if (status == "130") {
      return "status-invalid";
    }

    // иной статус - серый по умолчанию
    return "status-grey";
  },
  copyText(inputid) {
    let textarea = document.createElement("textarea");
    textarea.id = "temp";
    textarea.style.height = 0;
    document.body.appendChild(textarea);
    textarea.value = document.getElementById(inputid).value;
    let selector = document.querySelector("#temp");
    selector.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  },
  copyTextS(text, store) {
    let textarea = document.createElement("textarea");
    textarea.id = "temp";
    textarea.style.height = 0;
    document.body.appendChild(textarea);
    textarea.value = text
    let selector = document.querySelector("#temp");
    selector.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    store.commit('NOTIFICATION', {
      type: 'success',
      text: i18n.global.t('views.Home.41')
    })
  },
  checkIncassData(data) {
    const advanced = data.advanced;
    const tables = data.tables;

    let result = false;

    if (tables.length != 0) {
        tables.forEach(item => {
            if (item.colvalues.length != 0) {
                result = true;
            }
        })
    }

    if (advanced.incass_validator == '1' || 
        advanced.incass_card == '1' || 
        advanced.incass_card_reject == '1' || 
        advanced.incass_card_rr == '1'
    ) {
        result = true;
    }

    return result;
  },
  incassBalance(context, num_point, status) {
    context.axios.post('GetCountersIncassAtmRest', {data: {num_point: num_point, group_status: status}}).then(res => {
        if (res.data.body.result != '0') {
            return;
        }

        const resultCheckData = this.checkIncassData(res.data.body);
        
        // проверка наличия данных
        if (resultCheckData) {
            // запись данных в store
            context.$store.commit('SAVE_ATM_INCASS_REST_DATA', res.data.body);
            // переход
            context.$router.push('/ATM/atm_incass_balance');
            return;
        }

        // вывод ошибки
        const warningObject = {
            warningType: 'error',
            warningText: context.$t('views.ATM.60')
        }
        context.$store.commit("WARNING", warningObject);
    })
  },
  saveInitialColumns(context, data, actionsName=false) {
    const columns = JSON.parse(JSON.stringify(data));

    if (actionsName) {
        columns.actions = {name: context.$t(actionsName), type: '', show: ''};
    }

    for (let key in columns) {
        columns[key].key_name = key;
        columns[key].value = 
            columns[key].display == 'show' || key == 'actions' ? 
            true : false;
    }

    context.initialColSubs = Object.values(columns);
    context.initialColSubs.forEach((col, index) => col.id = index);
  },
  getColSubsWithoutHide(data) { 
    const columns = JSON.parse(JSON.stringify(data));
    console.log('columns', columns)
    const columnsWithoutHide = Object.entries(columns)
      .filter(([_, value]) => value.display !== 'hide')
      .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
      }, {});
    return columnsWithoutHide;
  },
  getColSubs(context, data, actionsName=false, dataSaved=false) {
    const columns = JSON.parse(JSON.stringify(data));
    if (actionsName) {
      columns.actions = {name: context.$t(actionsName), type: '', show: ''};
    }

    if (!dataSaved) {
        // столбцов не было в localStorage
        for (let key in columns) {
            columns[key].key_name = key;
            columns[key].value = 
                columns[key].display == 'show' || key == 'actions' ? 
                true : false;
        }

        context.colSubs = Object.values(columns);
        context.colSubs.forEach((col, index) => col.id = index);
    } else {
        // localStorage со столбцами
        context.colSubs = [];
        context.colSubs = Object.values(data);
    }
    context.colSubsFilter = context.colSubs.filter(item => item.value == true);

    const keys = context.colSubsFilter.map((item) => item.key_name);
    context.keys = keys.filter(item => item !== 'actions');
  },
  getFilteredData(columns, data, notRemove=false) {
    // console.log('lib columns', columns)
    const colSubsFilter = columns.filter(item => item.value == true);
    // console.log('lib colSubsFilter', colSubsFilter)

    let l = data;

    const filteredColValues = l.map(item => {
        return Object.keys(item)
            .filter(key => {
                return colSubsFilter.some(filter => filter.key_name === key && filter.value || notRemove && key == notRemove);
            })
            .reduce((obj, key) => {
                obj[key] = item[key];
                return obj;
            }, {});
    });

    return filteredColValues;
  },
  resetTable(context) {
    context.colSubs = [];
    context.colSubs = [...context.initialColSubs];
    // console.log('lib colSubs', context.colSubs);
    context.colSubsFilter = context.colSubs.filter(item => item.value == true);
    // console.log('lib colSubsFilter', context.colSubsFilter);
    context.data = this.getFilteredData(context.colSubs, context.initialData);
  },
  updateColumns(context, arg) {
    context.colSubs = [];
    context.colSubs = [...arg.colSubs];

    context.colSubsFilter = [...arg.colSubsFilter];
    context.data = [...arg.filteredData];
  },
  VAanimateOpen(target) {
    gsap.fromTo(target, { height: 10, opacity: 0 }, { height: "auto", duration: 0.4, ease: "power1.inOut", opacity: 1 });
  },
  VAanimateClose(target, done) {
    gsap.fromTo(target, {opacity: 0.8}, { height: 0, duration: 0.3, opacity: 0, ease: "power1.inOut", onComplete: done }).delay(0.1);
  },
  summValidate(arg) {
    return arg.replace(/\,/g, '.').replace(/\.+/g, '.').replace(/[^0-9.]/g, "").replace(/^\./, "");
  },
  routNewTab(url, router) {
    const routeData = router.resolve(url);
    window.open(routeData.href, '_blank');
  },
  isUrl(str) {
    let url;
    try {
        url = new URL(str);
    } catch (e) {
       return false;
    }
    return url.protocol === "http:" || url.protocol === "https:"
  },
  isValidIpList(str) {
    // Если строка пустая, это валидно
    if (!str || str.trim() === '') {
      return true;
    }
    
    // Регулярное выражение для проверки IPv4 адреса
    const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    
    // Разбиваем строку по запятым и проверяем каждый IP
    const ips = str.split(',').map(ip => ip.trim());
    
    for (let ip of ips) {
      if (ip === '') continue; // Пропускаем пустые элементы
      if (!ipv4Regex.test(ip)) {
        return false;
      }
    }
    
    return true;
  },
  booleanToString(arg) {
    if (typeof arg == 'boolean') {
        return arg ? '1' : '0';
    } 

    return arg;
  },
  formateDate(dateStr, datePartReverse = false) {
    if (datePartReverse) {
      const [year, month, day] = dateStr.split(' ')[0].split('-');
      const timePart = dateStr.split(' ')[1];
      if(timePart) {
        const [hours, minutes, seconds] = timePart.split(':');
        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
      } else {
        return `${day}.${month}.${year}`;
      }
    }
    
    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('.');
    const [hours, minutes, seconds] = timePart.split(':');

    const date = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);

    const monthNames = [
      i18n.global.t('views.Home.44'),
      i18n.global.t('views.Home.45'),
      i18n.global.t('views.Home.46'),
      i18n.global.t('views.Home.47'),
      i18n.global.t('views.Home.48'),
      i18n.global.t('views.Home.49'),
      i18n.global.t('views.Home.50'),
      i18n.global.t('views.Home.51'),
      i18n.global.t('views.Home.52'),
      i18n.global.t('views.Home.53'), 
      i18n.global.t('views.Home.54'),
      i18n.global.t('views.Home.55')
    ];

    const formatted = `${monthNames[date.getMonth()]} ${day}, ${year}, ${hours}:${minutes}:${seconds}`;
    return formatted;
  },
  checkPrecision(num, prec) {
    num = this.summValidate(num).toString();
    prec = Number(prec);
    const decimalIndex = num.indexOf('.');

    if (decimalIndex === -1) {
      return num;
    }

    const lengthEnd = num.length - (decimalIndex + 1);

    if (lengthEnd <= prec) {
      return num;
    }

    return num.slice(0, decimalIndex + prec + 1);
  },
  getComiss(context, params, cmd_name) {
    return context.axios.post('GetComiss', {no_loader: true, data: {
      cmd_params: params,
      cmd_name: cmd_name,
    }}).then(res => {
      if(res.data.body.result != 0) {
        return;
      }

      if (res.data.body.tables[0].colvalues.length > 0) {
        return res.data.body.tables[0].colvalues;
      } else {
        return 0;
      }
    })
  },
  summMask(sum) {
    if (!sum) {
      return '';
    }
    let arr = sum.split('.');
    if (arr[1]) {
      return `<span class='text-black neue fw-medium'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class='fsp10 primary-grey'>.${arr[1]}</span>`
    } else {
      return `<span class='text-black neue fw-medium'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
    }
  },

  // Для славянских языков 3: [один, несколько, много], например: ['Страна','Страны','Стран']
  // Для английских языков также 3: [один, много, много], например: ['Country','Countries', 'Countries']
  pluralize(count, forms) {
    if (!Array.isArray(forms) || forms.length === 0) {
      return '';
    }

    const numericCount = Math.abs(Number(count));
    if (Number.isNaN(numericCount)) {
      return forms[0];
    }
    if(count === 1 || (String(count).endsWith('1') && count !== 11)) {
      return forms[0];
    } else if((count >= 2 && count <= 4) || (count % 10 >= 2 && count % 10 <= 4)) {
      return forms[1];
    } else if((count >= 10 && count <= 19) || (count % 10 >= 5 && count % 10 <= 9) || (count % 10 === 0 && count !== 10)) {
      return forms[2];
    }
  },

  // Общий метод для редактирования P2P объявлений
  editOffer(context, row, updateCallback) {
    context.axios.post('GetparamsP2PProffer', {data: {code: row.code}}).then(res => {
      let proffer = false;
      if (res.data.body.result === '0') {
        proffer = res.data.body.advanced;
        proffer.code = row.code;
        proffer.external_type_text = row.external_type_text; 
        proffer.external_type_unit_precision = row.external_type_unit_precision ? row.external_type_unit_precision : 2;
        context.$store.commit('MODAL', {
          action: true,
          type: 'editP2P',
          content: {
            proffer: proffer,
            updateData: updateCallback
          }
        });
      }
    });
  },
  
  base64ToFile(base64, filename, mime) {
    const byteString = atob(base64)
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
    }

    return new File([ab], filename, { type: mime })
  },
};

export default lib;
